export var OPERAND_TYPE_VALUE = 'value';
export var OPERAND_TYPE_KEYWORD = 'keyword';
export var OPERAND_TYPE_FUNCTION = 'function';
export var OPERAND_TYPE_LIST = 'list';
export var OPERAND_EMPTY = 'empty';